/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Pagination_NextInputs */

const id_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berikutnya`)
};

const ms_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seterusnya`)
};

const da_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Næste`)
};

const de_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste`)
};

const en_us2_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

const es_es2_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente`)
};

const es_mx2_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente`)
};

const fil_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susunod`)
};

const fr_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivant`)
};

const it_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Successivo`)
};

const hu_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Következő`)
};

const nl_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volgende`)
};

const no_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neste`)
};

const pl_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Następna`)
};

const pt_br2_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

const pt_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguinte`)
};

const ro_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Următor`)
};

const fi_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuraava`)
};

const sv_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nästa`)
};

const vi_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếp`)
};

const tr_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonraki`)
};

const cs_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Další`)
};

const bg_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следващ`)
};

const ru_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Далее`)
};

const uk_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Далі`)
};

const ar_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التالي`)
};

const hi_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगला`)
};

const th_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถัดไป`)
};

const ja_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次へ`)
};

const zh_cn2_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

const zh_hant1_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

const ko_ui_pagination_next = /** @type {(inputs: Ui_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

/**
* | output |
* | --- |
* | "Next" |
*
* @param {Ui_Pagination_NextInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const ui_pagination_next = /** @type {((inputs?: Ui_Pagination_NextInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Pagination_NextInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_ui_pagination_next(inputs)
	if (locale === "ms") return ms_ui_pagination_next(inputs)
	if (locale === "da") return da_ui_pagination_next(inputs)
	if (locale === "de") return de_ui_pagination_next(inputs)
	if (locale === "en-US") return en_us2_ui_pagination_next(inputs)
	if (locale === "es-ES") return es_es2_ui_pagination_next(inputs)
	if (locale === "es-MX") return es_mx2_ui_pagination_next(inputs)
	if (locale === "fil") return fil_ui_pagination_next(inputs)
	if (locale === "fr") return fr_ui_pagination_next(inputs)
	if (locale === "it") return it_ui_pagination_next(inputs)
	if (locale === "hu") return hu_ui_pagination_next(inputs)
	if (locale === "nl") return nl_ui_pagination_next(inputs)
	if (locale === "no") return no_ui_pagination_next(inputs)
	if (locale === "pl") return pl_ui_pagination_next(inputs)
	if (locale === "pt-BR") return pt_br2_ui_pagination_next(inputs)
	if (locale === "pt") return pt_ui_pagination_next(inputs)
	if (locale === "ro") return ro_ui_pagination_next(inputs)
	if (locale === "fi") return fi_ui_pagination_next(inputs)
	if (locale === "sv") return sv_ui_pagination_next(inputs)
	if (locale === "vi") return vi_ui_pagination_next(inputs)
	if (locale === "tr") return tr_ui_pagination_next(inputs)
	if (locale === "cs") return cs_ui_pagination_next(inputs)
	if (locale === "bg") return bg_ui_pagination_next(inputs)
	if (locale === "ru") return ru_ui_pagination_next(inputs)
	if (locale === "uk") return uk_ui_pagination_next(inputs)
	if (locale === "ar") return ar_ui_pagination_next(inputs)
	if (locale === "hi") return hi_ui_pagination_next(inputs)
	if (locale === "th") return th_ui_pagination_next(inputs)
	if (locale === "ja") return ja_ui_pagination_next(inputs)
	if (locale === "zh-CN") return zh_cn2_ui_pagination_next(inputs)
	if (locale === "zh-Hant") return zh_hant1_ui_pagination_next(inputs)
	return ko_ui_pagination_next(inputs)
});
export { ui_pagination_next as "ui.pagination.next" }